<template>
  <div class="header-container" :style="{ width: width + 'px', left: left + 'px', top: top + 'px' }">
    <!-- 头部 -->
    <img class="group-tip" src="../../assets/images/1025/group-tip.png" />
    <div class="group-line"></div>
    <div class="group-think-line"></div>
    <div class="group-title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 100,
    },
    left: {
      type: Number,
      default: 0,
    },
    top: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {},
  created() {},
  async mounted() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
.header-container {
  position: absolute;
  display: flex;
  align-items: flex-end;

  .group-tip {
    display: inline-block;
    width: 66px;
    height: 38px;
  }

  .group-line {
    height: 1px;
    flex: 1;
    background-color: white;
  }

  .group-think-line {
    width: 8px;
    height: 3px;
    background-color: white;
  }

  .group-title {
    font-family: Adobe Heiti Std;
    font-size: 18px;
    color: #f9fafa;
    font-style: normal;
    text-transform: none;
    position: absolute;
    left: 66px;
    line-height: 38px;
    font-weight: bold;
  }
}
</style>
